import { z } from 'zod';
import { PAGINATION_SORT_DIRECTION } from '~/constants';

import {
  SUPPLIER_REQUEST_ORDER_BY,
  SUPPLIER_REQUEST_STATE,
} from '~/data/supplier-request';

import { ValidUuidOrNotSetSchema } from '@vestigas/utils';

export const zodSupplierRequestsListSearchParamsSchema = z.object({
  orderBy: z
    .enum(SUPPLIER_REQUEST_ORDER_BY)
    .optional()
    .prefault('requested_at')
    .catch('requested_at'),
  requestingCompanyAccountId: ValidUuidOrNotSetSchema.catch(undefined),
  requestingCompanyId: ValidUuidOrNotSetSchema.catch(undefined),
  searchString: z.string().trim().optional().prefault('').catch(''),
  sortOrder: z
    .enum(PAGINATION_SORT_DIRECTION)
    .optional()
    .prefault('DESC')
    .catch('DESC'),
  state: z
    .enum(SUPPLIER_REQUEST_STATE)
    .nullish()
    .prefault('pending')
    .catch('pending'),
});
